import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import {
  LoaderService, CommonService, UserInfoService,
  SortAlV1Service,
  AemService
} from 'abs-ngx-library/src/lib/core';
import { GridService } from 'src/app/shared/services/grid.service';
import { PageFlags } from 'src/app/shared/models/pageFlags.model';
import { take } from 'rxjs/operators';
import { BannerUnitProps } from 'src/app/shared/models/bannerUnits.model';
import { LogService } from 'src/app/shared/services/log.service';
import { EnviormentConfig } from 'abs-ngx-library/src/lib/core';
import { B4UService } from 'src/app/shared/services/b4u.service';
import { SortService, CouponModel } from 'src/app/shared/services/sort.service';
import { SortModel } from "../../../shared/models/data.model";
import { CommonService as b4UCommonService } from '../../../shared/services/common.service';
import { FilterType } from 'src/app/shared/models/filter-type';

@Component({
  selector: 'app-gallry-page',
  templateUrl: './gallry-page.component.html',
  styleUrls: ['./gallry-page.component.scss'],
})
export class GallryPageComponent implements OnInit {
  private _envConfig: any = EnviormentConfig;
  public baseCoupons: any = [];
  public userInfo: any;
  public _window: any = window;
  public hasSort: boolean = true;
  public filtersData: any;
  public couponGridType: string = 'couponsdeals';
  public couponsLimit: number = 0;
  public isBonusPath: boolean = false;
  public freshPassCouponEventListener: string[] = [];
  public displayNoResults: boolean = true;
  public allDealsGAMBannersDisabled = true;
  public pageFlags: PageFlags = {
    isBonusPathPage: false,
    isCouponsDealsPage: true,
    isOfferDetailsPage: false,
    isDiscoveryPage:false
  };
  public sideBannerUnitProps: BannerUnitProps = {
    pageName: 'coupon-deals',
    position: 'leftsideb1',
  };
  public topBannerUnitProps: BannerUnitProps = {
    pageName: 'coupon-deals',
    position: 'abs-carousel',
    isCarousel: true
  };
  public bottomNonEndemicBannerUnitProps: BannerUnitProps = {
    pageName: 'coupon-deals',
    position: 'bottomb1'
  }

  public activeSortRule: any;
  public couponGridEnableSort: boolean = true;
  public sortRules: SortModel[] = [];
  public smallScreen = window.innerWidth < 992;
  public showAds: boolean = false;
  public showCarousel: boolean = false;
  public isSessionValid: boolean = false;
  public isB2B: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.smallScreen = window.innerWidth < 992; // Check if width is below 992px
  }

  constructor(
    public authService: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private _loaderService: LoaderService,
    private _couponGridService: GridService,
    private commonService: CommonService,
    private userInfoService: UserInfoService,
    private _sortService: SortService,
    private absAemService: AemService,
    private _logService: LogService,
    private b4UService: B4UService,
    private b4uCommonService: b4UCommonService,
  ) {
    let galleryPageSortOptions: any = [ "purchase-history", "new-offers", "about-to-expire" ];
    let galleryPafeDefaultSortOptions: string = "category";
    this._window['AB']['availableSorts'] = galleryPageSortOptions;
    this._window['AB']['defaultSort'] = galleryPafeDefaultSortOptions;
    this._sortService.setAvailableSort(galleryPageSortOptions);
    this._sortService.generate();
    this.activeRoute.data.subscribe(
      (data: any) => {
        let isSessionValid = this.authService.isTokenValidForSession(
          data.tokenObject
        );
        this.isSessionValid = isSessionValid;
        if (isSessionValid) {
          const sessionData = {
            ...data.tokenObject,
            authToken: data.tokenObject['SWY_SHOP_TOKEN'],
          };
          if (sessionData) {
            if (sessionData.siteType === 'B') {
              sessionData['j4uStoreId'] = sessionData.storeId;
              sessionData['shopStoreId'] = sessionData.storeId;
            }
            this.userInfo = sessionData;
            const j4u = { j4u: { storeId: sessionData.j4uStoreId } };
            // this._window['AB'].userInfo = { ...sessionData, ...j4u };
            this.authService.updateUserInfo(sessionData);
            this.userInfoService.setUserSession(sessionData);
            this.commonService.postUserInfoSource.next('initFunc');
            this.commonService._postUserInfoSource.next('initFunc');
            this.isBonusPath = window.location.href.includes('bonus-path');
            if (this.isBonusPath) {
              this.pageFlags.isBonusPathPage = this.isBonusPath;
              this.pageFlags.isCouponsDealsPage = !this.isBonusPath;
            }
            // this.getCoupons();
            this.getselectFiltersFromUrl();
            this.allDealsGAMBannersDisabled = this.absAemService.getFeatureFlagByNameDisable('allDealsGAMBannersDisabled');
            this.b4uCommonService.setLeftNavActiveLink();
          }
        } else {
          // this.router.navigate(['/foru/foru-guest']);
          this.setEcommRedirectURLCookie();
          window.location.href = this.authService.getApplicationDomainURL() + '/foru-guest.html';
        }
      },
      (err) => {
        this.authService.redirectToSSO({});
      }
    );
  }

  ngOnInit(): void {
    this.getHiddenInputs();
    this.hasSort = this._sortService.hasSort();
    this.sortRules = this._sortService.getSorts();
    this.isB2B = this._window?.['AB']?.['userInfo']?.['siteType'] && this._window?.['AB']?.['userInfo']?.['siteType'] === 'B';
    if (this._window['AB'] && this._window['AB']['DATALAYER']) {
      this._window['AB']['DATALAYER'].initAngularSPA();
    }
    // Get default sort rule - purchaseRank
    this.activeSortRule = this._sortService.getDefaultSort();
    // this.showLoader();
    // setTimeout(() => this.showCarousel = true, 2500);
    // setTimeout(() => {
    //   this._logService.logRoundTrip();
    // },2000);
  }

  ngAfterViewInit() {
    this.showLoader();
    if (this.isSessionValid) this.getCoupons();
  }

  getselectFiltersFromUrl() {
    const filters: FilterType[] = [];
    const common = this._window['AB']['COMMON'];
    let filterCategoryParam = '', filterEventParam = '', filterOfferTypeParam = '';
    if (common && common.getURLParameterByName('category') !== null && common.getURLParameterByName('category') !== '') {
      filterCategoryParam = decodeURIComponent(<string>common.getURLParameterByName('category'));
      filterCategoryParam.split(/,(?=\S)/).map(el => {
          this.b4uCommonService.trackFilterUpdates(false, 'add', 'category', el);
          filters.push({
            filterName: el,
            filterType: 'Category',
            filterProperty: 'category'
          })
      });
    }

    if (common && common.getURLParameterByName('event') != null && common.getURLParameterByName('event') != '') {
      filterEventParam = decodeURIComponent(<string>common.getURLParameterByName('event'));
      filterEventParam.split(/,(?=\S)/).map(el => {
          this.b4uCommonService.trackFilterUpdates(false, 'add', 'events', el);
          filters.push({
            filterName: el,
            filterType: 'Events',
            filterProperty: 'events'
          })
      });
    }

    if (common && common.getURLParameterByName('offerPgm') != null && common.getURLParameterByName('offerPgm') != '') {
      filterOfferTypeParam = decodeURIComponent(<string>common.getURLParameterByName('offerPgm'));
      filterOfferTypeParam.split(/,(?=\S)/).map(el => {
          this.b4uCommonService.trackFilterUpdates(false, 'add', 'offerPgm', el);
          filters.push({
            filterName: el,
            filterType: 'Offer Type',
            filterProperty: 'offer-type'
          })
      });
    }
    if (filters?.length > 0) {
      this.b4uCommonService.trackFilterUpdates(true);
    }
    this.b4uCommonService._postSelectedFilters.next(filters);

  }


  public activeSortRuleEmitter(activeSortRule: any) {
    this.activeSortRule = activeSortRule;
    this.b4UService.activeSortEmitter.next(activeSortRule);
  }

  public getHiddenInputs(): void {
    const that = this;
    const inputs: NodeListOf<HTMLElement> = document.querySelectorAll('input[type=hidden]');
    console.warn(inputs);
    inputs.forEach((el: any, index: number) => {
      const val: any = el['value'];
      const elName: any = el['name'];
      console.warn(elName + ': ' + val);
      switch (elName) {
        case 'gridDataSource':
          this._window['AB'][elName] = JSON.parse(val);
          break;
        case 'availableSorts':
          this._window['AB'][elName] = [];
          val.split(',').map(function (elVal: any) {
            that._window['AB'][elName].push(elVal.trim());
          });
          break;
        default:
          this._window['AB'][elName] = val.toString();
          break;
      }
    });
  }

  public createFilterDataObject() {
    const TOP_CATEGORY_ITEM = 'Special Offers';
    const categories: any = [
      ...new Set(this.baseCoupons.map((category: any) => category.category)),
    ].sort((a: any, b: any) => {
      if (a === TOP_CATEGORY_ITEM) return -1;
      if (b === TOP_CATEGORY_ITEM) return 1;
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });
    const events = [
      ...new Set([...this.baseCoupons.map((coupon: any) => coupon.events).flat()]),
    ].sort((a: any, b: any) => (a < b ? -1 : a > b ? 1 : 0));
    const offerTypes = [
      ...new Set([...this.baseCoupons.map((coupon: any) => coupon.offerType)]),
    ].sort((a: any, b: any) => (a < b ? -1 : a > b ? 1 : 0));
    const couponTypes =
      this._window['SWY'].CONFIGSERVICE.nimbusConfig.filterCouponTypes;
    const newOfferTypes: any = [];
    offerTypes.forEach((ct) => newOfferTypes.push(couponTypes[ct]));

    const filtersData = [
      {
        property: 'category',
        label: 'Category',
        values: categories.map((category: string) => ({ name: category })),
        displaySpacer: true
      },
      {
        property: 'events',
        label: 'Events',
        values: events.map((e: string) => ({ name: e })),
        displaySpacer: true
      },
      {
        property: 'offer-type',
        label: 'Offer Type',
        values: newOfferTypes.map((ot: string) => ({ name: ot })),
        displaySpacer: true
      },
    ];
    console.warn(filtersData);
    return {
      data: filtersData,
      showClearAllFilters: true,
      showCount: false,
      displayLimitedFilter: false
    };
  }

  private showLoader(): void {
    this._loaderService.show();
  }

  private hideLoader(): void {
    this._loaderService.hide();
  }

  public setEcommRedirectURLCookie() {
    let ecomCookieUrl;
    let currentPagePath = window.location.pathname + window.location.search;
    ecomCookieUrl = 'ACI_S_ECommRedirectURL'

    if (this.isB2B) {
      ecomCookieUrl = 'ACI_S_B_ECommRedirectURL';
    }
    this._window['AB']['COMMON']?.setCookie(ecomCookieUrl, encodeURI(currentPagePath));
  }

  public getCoupons() {
    this._couponGridService
      .getData(
        this.couponsLimit,
        this.couponGridType,
        this.freshPassCouponEventListener,
        this.isBonusPath
      )
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          this.baseCoupons = data;
          this.filtersData = this.createFilterDataObject();
          this.showAds = true;
          this.hideLoader();
        },
        (err: any) => {
          console.log('Error: ', err);
          this.baseCoupons = [];
          this.displayNoResults = true;
          // $('#loadingConMedium').remove();
          this._window['AB']['DATALAYER'].setCouponsDetails(
            this.baseCoupons.length,
            this._couponGridService.couponSource
          );
          let strError = 'Coupon API failed. Status: ' + err.status;

          this._window['AB']['DATALAYER'].setError(
            this.couponGridType + '-grid',
            this.couponGridType + ' Grid',
            strError
          );
          this.showAds = true;
          this.hideLoader();
        });
  }


}
